import fetchAPI from '../../fetchAPI';
import { useQuery } from '@tanstack/react-query';

type Props = {
  locationId?: string;
  pageNumber?: string;
  pageSize?: string;
};

export const useKnowledgeBase = ({ locationId, pageNumber, pageSize }: Props) => {
  const query = new URLSearchParams();

  if (locationId) query.append('locationId', locationId);
  if (pageNumber) query.append('pageNumber', pageNumber);
  if (pageSize) query.append('pageSize', pageSize);

  return useQuery({
    queryKey: [`/knowledge/location/${locationId}`, locationId, pageNumber, pageSize],
    queryFn: async () => {
      const response = await fetchAPI<Pagination<CoreKnowledgeBase>>({
        method: 'GET',
        route: `/knowledge/location/${locationId}`,
        queryString: query.toString(),
        isZazu: true
      });

      return response;
    },
    enabled: !!locationId // Query will only run if type is provided
  });
};

export default useKnowledgeBase;
